import { render, staticRenderFns } from "./MagazinePage.vue?vue&type=template&id=49851c10&scoped=true&"
import script from "./MagazinePage.vue?vue&type=script&lang=js&"
export * from "./MagazinePage.vue?vue&type=script&lang=js&"
import style0 from "./MagazinePage.vue?vue&type=style&index=0&id=49851c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49851c10",
  null
  
)

export default component.exports